module.exports = __webpack_public_path__ + "src/assets/img/1xFarm.050b4227.png";